import "../styles/Footer.css";
import Logo from "../images/logo-white.png"

export default function Footer({ setPage }) {
  const links = ["home", "gallery", "shop", "classroom", "about"];

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div>
            <div className="footer-brand">
              <img src={Logo} alt="DSON Art Logo" className="nav-logo-img" />
            </div>
            
            <p className="footer-desc">
              A premier fine art gallery and studio in Zanzibar, celebrating African
              creativity through exhibitions, education, and the joy of collecting
              original art.
            </p>
          </div>

          <div>
            <div className="footer-nav-title">Navigate</div>
            {links.map((p) => (
              <div
                key={p}
                className="footer-nav-link"
                onClick={() => setPage(p)}
              >
                {p.charAt(0).toUpperCase() + p.slice(1)}
              </div>
            ))}
          </div>

          <div>
            <div className="footer-nav-title">Contact</div>
            {/* 📌 UPDATE YOUR CONTACT DETAILS BELOW */}
            <div className="footer-nav-link">📍 Zanzibar, Tanzania</div>
            <div className="footer-nav-link">✉ info@dicksonart.co.tz</div>
            <div className="footer-nav-link">📞 +255 000 000 000</div>
          </div>

        </div>

        <div className="footer-bottom">
          <div className="footer-copy">
            © 2025 Dickson Art Gallery · All Rights Reserved · Zanzibar, Tanzania
          </div>
          <div className="footer-craft">Crafted with passion for art</div>
        </div>
      </div>
    </footer>
  );
}
